import React, { useState, useEffect } from "react";
import { ShieldCheck } from "lucide-react";
import { API } from "@/lib/api";

// Cache buster shared across the app
let cacheBust = Date.now();
const listeners = new Set();
export function bumpLogoCache() {
  cacheBust = Date.now();
  listeners.forEach((cb) => cb(cacheBust));
}

export default function BrandLogo({ size = 36, rounded = "rounded-md", className = "" }) {
  const [version, setVersion] = useState(cacheBust);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const cb = (v) => { setVersion(v); setFailed(false); };
    listeners.add(cb);
    return () => listeners.delete(cb);
  }, []);

  const url = `${API}/settings/logo?v=${version}`;

  if (failed) {
    return (
      <div
        className={`${rounded} bg-slate-900 flex items-center justify-center ${className}`}
        style={{ width: size, height: size }}
      >
        <ShieldCheck className="text-white" style={{ width: size * 0.55, height: size * 0.55 }} strokeWidth={2.2} />
      </div>
    );
  }

  return (
    <img
      src={url}
      alt="Logo"
      onError={() => setFailed(true)}
      className={`${rounded} object-contain bg-white ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
